import React from "react";
import { CardLayout } from "components/cardLayout";
import { CardItem } from "components/cardItem";
import "./PayDeposit.scss"
import { TextField } from "components/textField";
import { Button } from "components/button";
import { CardTitle } from "components/cardTitle";
import { PageHeading } from "components/pageHeading";
import { FormControl, FormGroup, FormBuilder, Validators } from "react-reactive-form";
import { ErrorMessage } from "components/errormessage";
import {postPayDeposit} from '../../core/services/payDepositService'
import axios from 'axios';
import {processPayment} from '../../core/services/processPayment'
import { client } from "App";
import { navigate } from "@reach/router";
import { callAnalytics } from "core/services/GlobalService";

var  LeadDetails:any =[];
export interface PayDepositProps {

}

export interface PayDepositState {
    disabled:boolean;
    submitted: boolean;
    loading?: boolean;
    errorMessage?: string;
    LeadDetails:any;
    amounts:any
}

class PayDeposit extends React.Component<PayDepositProps, PayDepositState> { 
    private formGroup: FormGroup;
    private _isMounted: boolean = false;
    constructor(props: PayDepositProps) {
        super(props);
        this.state = {
            disabled:true,
            submitted: false,
            loading: false,
            errorMessage: '',
            LeadDetails: JSON.parse(localStorage.getItem("customerDetails")||'{}'),
            amounts :JSON.parse(localStorage.getItem("amounts") || '{}')
        };

        this.onFormChange = this.onFormChange.bind(this);

/*         this.formGroup = FormBuilder.group({
            name: new FormControl("", [Validators.required]),
            cardno: new FormControl("5567356088662085", [Validators.required]),
            expiryMM: new FormControl("04", [Validators.required]),
            expiryYY: new FormControl("23", [Validators.required]),
            cvv: new FormControl("584", [Validators.required]),
            zip: new FormControl("75209", [Validators.required]),
        }); */
    
        this.formGroup = FormBuilder.group({
            name: new FormControl("", [Validators.required]),
            cardno: new FormControl("", [Validators.required]),
            expiryMM: new FormControl("", [Validators.required]),
            expiryYY: new FormControl("", [Validators.required]),
            cvv: new FormControl("", [Validators.required]),
            zip: new FormControl("", [Validators.required]),
        });
        this.formGroup.valueChanges.subscribe(this.onFormChange);
    }

    onFormChange(value: any) {
        console.log(value);
       
        if (this.formGroup.valid && this.state.disabled) {
            this.setState({ disabled: false });
        } else {
            this.setState({ disabled: true });
        }
    }

    detectCardType = (cardNumber: any) => {
    //detectCardType(cardNumber:any){
        //    	var regex = {
        //	        electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
        //	        maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
        //	        dankort: /^(5019)\d+$/,
        //	        interpayment: /^(636)\d+$/,
        //	        unionpay: /^(62|88)\d+$/,
        //	        visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
        //	        mastercard: /^5[1-5][0-9]{14}$/,
        //	        amex: /^3[47][0-9]{13}$/,
        //	        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        //	        discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        //	        jcb: /^(?:2131|1800|35\d{3})\d{11}$/
        //	    }
        var regex=[
                { key: '1', title: "Visa",pattern:/^4[0-9]{12}(?:[0-9]{3})?$/},
                { key: '2', title: "AmericanExpress",pattern:/^3[47][0-9]{13}$/},
                { key: '3', title: "MasterCard",pattern:/^5[1-5][0-9]{14}$/},
                { key: '4', title: "Discover",pattern:/^6(?:011|5[0-9]{2})[0-9]{12}$/},
            ];
                
        var keepGoing = true;
        var matchedCard=null;

        regex.forEach((item, index) => {
            console.log(JSON.stringify(item));
            if(keepGoing) {
                if(item.pattern.test(cardNumber)) {
                    console.log("key:"+item.key+",title:"+item.title+",pattern:"+item.pattern+",idx:"+index);
                    keepGoing = false;
                    matchedCard= item;
                }
            }
        })
        return matchedCard;
    }

    componentDidMount() {
        this._isMounted = true;
        LeadDetails= JSON.parse(localStorage.getItem("customerDetails")||'{}')
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async saveDetails(){
        LeadDetails= JSON.parse(localStorage.getItem("customerDetails")||'{}')
        console.log(LeadDetails.moveDailySheetID)
        console.log(LeadDetails.customerID)
        this.setState({ submitted: true });
        
       if( this.formGroup.valid){
            var totalAmt = this.state.amounts.find((item:any)=>item.type==="Total").amount
            var deposit = this.state.amounts.find((item:any)=>item.type==="Deposit").amount

            let currDate = new Date()
            let cDate = currDate.getDate();
            let cMonth = currDate.getMonth() + 1;
            let cYear = currDate.getFullYear();


            var name=this.formGroup.get("name").value;
            var cvv=this.formGroup.get("cvv").value;
            var zip=this.formGroup.get("zip").value;
            var cardNo=this.formGroup.get("cardno").value;
            var cardType:any=this.detectCardType(this.formGroup.get("cardno").value);
            // var expiry=this.formGroup.get("expiry").value;
            // var month=expiry.split("/")[0];
            // var year=expiry.split("/")[1];

            var month=this.formGroup.get("expiryMM").value;
            var year=this.formGroup.get("expiryYY").value;

            if(name.length==0){
                this.setState({errorMessage: "Please enter valid card details"});
                //this.setState({errorMessage: "Please enter name"});
                return;
            }
            else if(cardType==null){
                this.setState({errorMessage: "Please enter valid card details"});
                //this.setState({errorMessage: "Please enter valid card number"});
                return;
            }
            else if(parseInt(month)<=0 || parseInt(month)>12){
                this.setState({errorMessage: "Please enter valid card details"});
                //this.setState({errorMessage: "Please enter valid expiry month"});
                return;
            }
            else if(parseInt(year)<20 ){
                this.setState({errorMessage: "Please enter valid card details"});
                //this.setState({errorMessage: "Please enter valid expiry year"});
                return;
            }
            else if(parseInt(year)==cYear && month<cMonth ){
                this.setState({errorMessage: "Please enter valid card details"});
                //this.setState({errorMessage: "Please enter valid expiry month or year"});
                return;
            }
            else if(cardType.key!=2 && cvv.length!=3){
                this.setState({errorMessage: "Please enter valid card details"});
                //this.setState({errorMessage: "Please enter valid cvv"});
                return;
            }
            else if(cardType.key==2 && cvv.length!=4){
                this.setState({errorMessage: "Please enter valid card details"});
                //this.setState({errorMessage: "Please enter valid cvv"});
                return;
            }
            else if(zip.length!=5){
                this.setState({errorMessage: "Please enter valid card details"});
                //this.setState({errorMessage: "Please enter valid zip code"});
                return;
            }
            this.setState({errorMessage: ""});
            var params = {
                CustomerID: LeadDetails.customerID,
                MoveDailySheetId: LeadDetails.moveDailySheetID,
                BranchID: LeadDetails.branchID,
                CardNumber: cardNo,
                // Amount: "1",
               Amount: deposit.toString(),
                Expiredate: month+''+year,
                Zipcode: zip,
                CustomerName:name,
                CardType: (cardType)?cardType.key:"",
                Cvv:cvv,
                PaymentType: "6"
            };
            this.setState({ loading: true });

            this.processPayment(params)
            .then( async response  => {
                console.log(JSON.stringify(response));
                this.setState({ loading: false });
               if(response.data.processPayment[0].responseCode==="200"){
                    //alert("Your payment approved");
                    const eventType = "Booked"
                    let callAnalyticsResponse = await callAnalytics (LeadDetails, eventType)
                    console.log(" callAnalyticsResponse after payment done: ", callAnalyticsResponse);
                    navigate("/newThankyou");
               }else{
                    alert("Your payment not approved");
               }
            });
        }else{
            this.setState({ disabled: true });
        }
    }

    async processPayment(params:any) {
        return client.query({
            query: processPayment, variables: {
                paymentInput: {
                    "customerID":  params.CustomerID,
                    "moveDailySheetId":  params.MoveDailySheetId,
                    "branchID":   params.BranchID,
                    "cardNumber":   params.CardNumber,
                    "amount":   params.Amount,
                    "expiredate":   params.Expiredate,
                    "zipcode":   params.Zipcode,
                    "customerName":  params.CustomerName,
                    "cardType":   params.CardType,
                    "cvv":  params.Cvv,
                    "paymentType":   params.PaymentType,
                }
            }
        });

    }

    nextPage(){
        navigate("/newThankyou");
    }

    onEnter() {
        window.scrollTo(0,0);
    }

    render() {
        // var amounts="0", total=0;
        
        // var totalAmt = this.state.amounts.find((item:any)=>item.type==="Total").amount
        // var deposit = this.state.amounts.find((item:any)=>item.type==="Deposit").amount
        // var balance = totalAmt - deposit;

        var totalAmt = this.state.amounts.find((item:any)=>item.type==="Total").amount
        var deposit = this.state.amounts.find((item:any)=>item.type==="Deposit").amount
        var balance = totalAmt - deposit;
        return (
            <div className="deposit-container">
            <div className="inner-wrapper">
            <div className="deposit-title">         
                 <h1>Book Your Move</h1>
                </div>
              <div className="deposit-subtitle">
                    <h2>Pay a deposit of ${deposit} and the rest on your move day.</h2>
                </div>
                <CardLayout style={{padding: "0em 2em 3em 2em"}}>
                
                    <div className="error">
                        <ErrorMessage text={this.state.errorMessage} />
                    </div>
                    <div className="paydeposit-form">
                        <TextField
                            keyboardType={"text"}
                            label={"Name On Card"}
                            formControl={this.formGroup.get("name") as FormControl}
                            submitted={this.state.submitted}
                            onFocusOut={this.onEnter}
                        />
                        <TextField
                            keyboardType={"tel"}
                            label={"Card Number"}
                            formControl={this.formGroup.get("cardno") as FormControl}
                            submitted={this.state.submitted}
                            onFocusOut={this.onEnter}
                        />
                    </div>
                    <div className="bottom-fields">
                        {/* <div className="textfield-bottom"> */}
                        <div className="cvv-field">
                            <TextField
                                keyboardType={"tel"}
                                label={"MM"}
                                formControl={this.formGroup.get("expiryMM") as FormControl}
                                submitted={this.state.submitted}
                                errorText={"Required"}
                                onFocusOut={this.onEnter}
                            />
                        </div>
                        <div className="cvv-field">
                            <TextField
                                keyboardType={"tel"}
                                label={"YY"}
                                formControl={this.formGroup.get("expiryYY") as FormControl}
                                submitted={this.state.submitted}
                                errorText={"Required"}
                                onFocusOut={this.onEnter}
                            />
                        </div>
                        <div className="cvv-field">
                            <TextField
                                keyboardType={"tel"}
                                label={"CVV"}
                                formControl={this.formGroup.get("cvv") as FormControl}
                                submitted={this.state.submitted}
                                errorText={"Required"}
                                onFocusOut={this.onEnter}
                            />
                        </div>
                        <div className="textfield-bottom">
                            <TextField
                                keyboardType={"tel"}
                                label={"Zipcode"}
                                formControl={this.formGroup.get("zip") as FormControl}
                                submitted={this.state.submitted}
                                errorText={"Required"}
                                onFocusOut={this.onEnter}
                            />
                        </div>
                    </div>
                </CardLayout>
                <div className="deposite-amount">
                    <div className="deposit-text">
                        <h2>Move Deposit</h2>
                        {/* <h2>${(this.state.amounts.length>1 && this.state.amounts[1].amount)?this.state.amounts[1].amount:"0"}</h2> */}
                        {/* <h2>${Number(deposit).toFixed(2)}</h2> */}
                        <h2>${deposit}</h2>
                    </div>
                    <div className="divider-line"></div>
                    <div className="remaining-balane">
                        <h3>The remaining balance of ${balance} will be due on your Move Day.</h3>
                        {/* <h3>${this.state.amounts[0].amount-this.state.amounts[1].amount}</h3> */}
                        {/* <h3>${balance}</h3> */}
                    </div>
                </div>
                <div className="finish-btn">
                    <Button
                        text={"Pay deposit"}
                        disabled={this.state.disabled}
                        onClick={() => this.saveDetails()}
                       loading={this.state.loading}
                       formControl={this.formGroup.get('saveDetails') as FormControl}
                       formGroup={this.formGroup}
                    />

                    {/* <Button
                        text={"Pay Now"}
                        onClick={() => this.nextPage()}
                    /> */}

                </div>
            </div>
            </div>

        );
    }
}

export default PayDeposit;